import React from "react";
import Logo from "../identity/logo";

interface NavigationProps {
  className?: string;
}

const Navigation: React.FC<NavigationProps> = ({ className = "" }) => {
  return (
    <nav
      className={`flex items-center justify-between px-4 sm:px-6 lg:px-8 py-4 sm:py-5 w-full mb-5 sm:mb-8 ${className}`}
      role="navigation"
      aria-label="Main navigation"
    >
      {/* Logo */}
      <div className="flex-shrink-0">
        <a href="/" className="block">
          <Logo />
        </a>
      </div>

      {/* Navigation Links - Hidden on small screens, visible on medium and up */}
      <div className="hidden md:flex items-center gap-4 lg:gap-6">
        <a
          href="/projects/"
          className="font-medium text-sm lg:text-base text-black transition-colors hover:bg-neutral-99 rounded-[40px] py-3 lg:py-4 px-4 lg:px-7"
        >
          Projects
        </a>
        <a
          href="/news/"
          className="font-medium text-sm lg:text-base text-black transition-colors hover:bg-neutral-99 rounded-[40px] py-3 lg:py-4 px-4 lg:px-7"
        >
          News
        </a>
        <a
          href="/about-us/"
          className="font-medium text-sm lg:text-base text-black transition-colors hover:bg-neutral-99 rounded-[40px] py-3 lg:py-4 px-4 lg:px-7"
        >
          About
        </a>
        <a
          href="/contact/"
          className="bg-black text-white font-medium text-sm lg:text-base rounded-[40px] py-3 lg:py-4 px-4 lg:px-7 hover:opacity-90 transition-opacity"
        >
          Contact
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
